import request from '@/utils/request'

// 查询模板合同申领审核明细列表
export function listApplyCont(query) {
  return request({
    url: '/cont/apply/list',
    method: 'get',
    params: query,
    options: {
      loading: true
    }
  })
}

// 新增模板合同申领审核明细
export function addApplyCont(data) {
  return request({
    url: '/cont/apply',
    method: 'post',
    data: data,
    options: {
      loading: true
    }
  })
}

// 修改模板合同申领审核明细
export function modifyApplyCont(data) {
  return request({
    url: '/cont/apply',
    method: 'put',
    data: data,
    options: {
      loading: true
    }
  })
}

// 删除模板合同申领审核明细
export function deleteApplyCont(templateApplyId) {
  return request({
    url: '/cont/apply/' + templateApplyId,
    method: 'delete'
  })
}

// 获取模板合同申领审核明细详细信息
export function getApplyCont(templateApplyId) {
  return request({
    url: '/cont/apply/' + templateApplyId,
    method: 'get',
    options: {
      loading: true
    }
  })
}

// 审核
export function auditApplyCont(data) {
  return request({
    url: '/cont/apply/reviewer',
    method: 'post',
    data: data
  })
}

// 查询模板合同申领主列表(申领合同记录)
export function listApplyDecord(query) {
  return request({
    url: '/cont/sale/list',
    method: 'get',
    params: query,
    options: {
      loading: true
    }
  })
}

// 查询使用明细
export function listApplyUsed(query) {
  return request({
    url: '/cont/detail/list',
    method: 'get',
    params: query,
    options: {
      loading: true
    }
  })
}

// 查询合同管理列表
export function listContract(query) {
  return request({
    url: '/cont/contract/list',
    method: 'get',
    params: query
  })
}

// 查询合同管理详细
export function getContract(contractId) {
  return request({
    url: '/cont/contract/' + contractId,
    method: 'get'
  })
}

// 新增合同管理
export function addContract(data) {
  return request({
    url: '/cont/contract',
    method: 'post',
    data: data
  })
}

// 修改合同管理
export function updateContract(data) {
  console.log('contract:' + JSON.stringify(data))
  return request({
    url: '/cont/contract',
    method: 'put',
    data: data
  })
}

// 删除合同管理
export function delContract(contractId) {
  return request({
    url: '/cont/contract/' + contractId,
    method: 'delete'
  })
}

// 导出合同管理
export function exportContract(query) {
  return request({
    url: '/cont/contract/export',
    method: 'get',
    params: query
  })
}

// 审核合同
export function reviewer(data) {
  return request({
    url: '/cont/contract/reviewer',
    method: 'post',
    data
  })
}
